module.exports = __webpack_public_path__ + "res/img_ph_b.0831697edfc70e5cb47d0a0cb54b3558.png";